import { Injectable } from '@angular/core';
import { initializeApp } from 'firebase/app';
import { getRemoteConfig, fetchAndActivate, getString, getBoolean, RemoteConfig } from 'firebase/remote-config';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FirebaseService {

  private remoteConfig: RemoteConfig;

  constructor() {
    const app: any = initializeApp(environment.firebase);

    this.remoteConfig = getRemoteConfig(app);

    this.remoteConfig.settings = {
      minimumFetchIntervalMillis: 30000,
      fetchTimeoutMillis: 60000
    };

    this.remoteConfig.defaultConfig = {
      [`maintenance_${environment.env_name}`]: 'false',
      ['maintenance_manager_message']: JSON.stringify({
        fr: 'Maintenance en cours.',
        en: 'Maintenance in progress.'
      })
    };
  }

  async isMaintenanceMode(): Promise<boolean> {
    try {
      await fetchAndActivate(this.remoteConfig);

      return getBoolean(this.remoteConfig, `maintenance_${environment.env_name}`);
    } catch {
      return false;
    }
  }

  async getMaintenanceMessage(lang: string): Promise<string | null> {
    try {
      await fetchAndActivate(this.remoteConfig);

      const messages: any = JSON.parse(getString(this.remoteConfig, 'maintenance_manager_message'));

      return messages[lang] || messages['fr'] || null;
    } catch {
      return null;
    }
  }

}
